export type ReportSearchState = {
  searchBy?: string
  textValue?: unknown
  marksValue?: unknown
  tagsValue?: unknown
  tagsLogicalRelation?: unknown
  textLogicalRelation?: unknown
  marksFilterMode?: string
}

export function hasReportFilterValue(value: unknown): boolean {
  if (value == null) return false
  if (typeof value === 'string') return value.trim() !== ''
  if (Array.isArray(value)) {
    return value.some((item) => {
      if (item != null && typeof item === 'object' && 'value' in item) {
        return hasReportFilterValue((item as { value: unknown }).value)
      }
      return hasReportFilterValue(item)
    })
  }
  return true
}

export function reportSearchRequestParams(
  search: ReportSearchState | null | undefined,
  options?: { textExact?: boolean }
): Record<string, unknown> {
  if (!search?.searchBy) return {}

  const {
    searchBy,
    textValue,
    marksValue,
    tagsValue,
    tagsLogicalRelation,
    textLogicalRelation,
    marksFilterMode,
  } = search

  const isText = options?.textExact ? searchBy === 'text' : searchBy.startsWith('text')
  if (isText) {
    if (!hasReportFilterValue(textValue)) return {}
    if (options?.textExact) return { searchBy, search: textValue }
    return {
      searchBy: 'text',
      textLogicalRelation,
      search: textValue,
    }
  }

  if (options?.textExact) return {}

  if (searchBy === 'marks' || searchBy.startsWith('marks-')) {
    if (!hasReportFilterValue(marksValue)) return {}
    return {
      searchBy: 'marks',
      marks: marksValue,
      marksFilterMode: marksFilterMode
        || (searchBy.includes('exclude') ? 'exclude' : 'include'),
    }
  }

  if (searchBy.startsWith('tags')) {
    if (!hasReportFilterValue(tagsValue)) return {}
    return {
      searchBy: 'tags',
      tagsLogicalRelation,
      tags: tagsValue,
    }
  }

  return {}
}

export function reportSearchUrlParams(
  search: ReportSearchState | null | undefined
): Record<string, unknown> {
  const params = reportSearchRequestParams(search)
  if (Object.keys(params).length || !search?.searchBy) return params

  const { searchBy, textLogicalRelation, tagsLogicalRelation, marksFilterMode } = search

  if (searchBy.startsWith('text')) {
    return {
      searchBy: 'text',
      textLogicalRelation: textLogicalRelation || (searchBy.includes('or') ? 'or' : 'and'),
    }
  }

  if (searchBy.startsWith('tags')) {
    return {
      searchBy: 'tags',
      tagsLogicalRelation: tagsLogicalRelation || (searchBy.includes('or') ? 'or' : 'and'),
    }
  }

  if (searchBy === 'marks' || searchBy.startsWith('marks-')) {
    return {
      searchBy: 'marks',
      marksFilterMode: marksFilterMode
        || (searchBy.includes('exclude') ? 'exclude' : 'include'),
    }
  }

  return {}
}
